import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import '@livekit/components-styles'
import './index.css'

// After a deploy, tabs opened earlier reference chunk files that no longer exist on the server.
// Reload once to pick up the new index.html. The guard stops a reload loop if a chunk is truly broken,
// in which case the error falls through to the route error boundary.
// See https://vite.dev/guide/build.html#load-error-handling
const PRELOAD_RELOAD_KEY = 'vite-preload-error-reload-at'
window.addEventListener('vite:preloadError', (event) => {
    const lastReloadAt = Number(sessionStorage.getItem(PRELOAD_RELOAD_KEY) ?? 0)
    if (Date.now() - lastReloadAt < 10_000) {
        return
    }
    sessionStorage.setItem(PRELOAD_RELOAD_KEY, String(Date.now()))
    event.preventDefault()
    window.location.reload()
})

ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
        <App />
    </React.StrictMode>,
)


